<template>
  <div class="mainSec">
    <v-card width="600" class="mainCard">
      <v-card-title>Регистрация</v-card-title>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col
                cols="12"
            >
              <v-text-field
                  v-model="username"
                  :rules="rules"
                  label="Логин"
                  required
              >
                <v-icon
                    slot="prepend"
                    color="blue"
                >
                  mdi-account
                </v-icon>
              </v-text-field>
              <v-text-field
                  v-model="password"
                  :rules="passRules"
                  label="Пароль"
                  type="password"
                  required
              >
                <v-icon
                    slot="prepend"
                    color="blue"
                >
                  mdi-lock
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-btn
          class="mt-4 align-center"
          color="primary"
          block
          large
          elevation="2"
      >
        Регистрация
      </v-btn>
      <div class="d-flex justify-center mt-4">
        У вас уже есть аккаунт?<router-link to="/login" class="mx-2">Авторизоваться</router-link>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "SignupPage",
  data () {
    return {
      valid: false,
      username: '',
      password: '',
      rules: [
        v => !!v || 'Введите логин'
      ],
      passRules: [
        v => !!v || 'Введите пароль',
        v => v.length >= 4 || 'Пароль должен быть больше 4 символов',
      ]
    }
  }
}
</script>

<style scoped>
.mainSec {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.mainCard {
  padding: 50px 50px;
}
</style>
